import React from 'react';

import LocalSettingsTab from '@shared/components/LocalSettingsTab';

/**
 * Страница локальных настроек в пользовательской части
 */
const MyProfileLocalSettings = () => {
  return (
    <LocalSettingsTab
      showTitle={false}
      translationNamespace={['myProfile', 'localSettings']}
      containerStyle={{ padding: 0 }}
    />
  );
};

export default MyProfileLocalSettings;
